<template lang="pug">
  .faq-block-item(itemscope itemprop="mainEntity" itemtype="https://schema.org/Question")
    SpoilerItem
      template(#spoiler_title)
        span.faq-block-item__question(itemprop="name" v-html="faqItem.question")
      template(#default)
        div.faq-block-item__answer(itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer")
          div(itemprop="text" v-html="faqItem.answer")
</template>
<script>
import SpoilerItem from "../../spoiler/vue/SpoilerItem";
export default {
  name: "FaqItem",
  components: {
    SpoilerItem,
  },
  props: {
    faqItem: {
      type: Object,
      required: true,
    },
  },
};
</script>
